export default "__VITE_ASSET__0edf03cd__"